import { useSelector } from "react-redux";

export const useGetReduxListings = () => {
  const listings = useSelector((state) => state.schedule);
  return { listings };
};
